import { logout } from "@/hooks/login/useLogin";
import { ElMessageBox } from "element-plus";

interface LogoutCallBack {
  userid: string;
  subid: string;
  id: string;
  message: string;
  pt: string;
  Status: number;
}

export const initLogout = (connection: any) => {
  connection.on("logoutCallBack", function (row: string) {
    console.log("-------------------------------接收到消息------------------------------");
    console.log(row);
    const { message } = JSON.parse(row) as LogoutCallBack;
    ElMessageBox.alert(message, "提示", {
      confirmButtonText: "确定",
      callback: () => {
        logout();
      },
    });
  });
};
